import React, { } from "react";
import { View, Grid, Card, useTheme, SelectField, Label } from "@aws-amplify/ui-react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ThemeProvider,
  Theme,
  Button,
} from '@aws-amplify/ui-react';

import MiniStatistics from "./MiniStatistics";
import GaugeChart from 'react-gauge-chart'

import "./Conversations.css";
import TitleSection from "../../components/titlesection/TitleSection";
import Productivity from "../../components/Productivity/Productivity";


const theme: Theme = {
  name: 'table-theme',
  tokens: {
    components: {
      table: {
        row: {
          hover: {
            backgroundColor: { value: '{colors.white.10}' },
          },

          striped: {
            backgroundColor: { value: '{colors.white.10}' },
          },
        },

        header: {
          color: { value: '{colors.black.80}' },
          fontSize: { value: '{fontSizes.sl}' },
        },

        data: {
          fontWeight: { value: '{fontWeights.semibold}' },
        },
      },
    },
  },
};

const productivityData = {
  title: "Conversations Action Summary",
}

const Conversations = () => {
  const { tokens } = useTheme();

  const label = [
    "Find document",
    "Send email",
    "Summarize",
    "Search Text",
  ]
  const trafficSourceData = [102, 65, 120, 145]
  const colors = ["#2d8bba", "#6ce5e8", "#38b6ff", "#5271ff"]
  return (
    <>
      <TitleSection title="Conversations" />
      <View borderRadius="6px" maxWidth="100%" padding="0rem" minHeight="100vh">
        <Grid
          templateColumns={{ base: "1fr", large: "1fr 3fr" }}
          gap={tokens.space.xl}
        >
          <View>
            <View rowSpan={{ base: 1, large: 1 }}>
              <MiniStatistics
                title="Conversations Sessions"
                amount="489"
                percentage={"18"}
                progress={"65"}
                bgcolor={"#e2ffed"}
                textcolor={"#008425"}
              />
            </View>
            <View>
              <Card height="100%" borderRadius="15px" className="meter-card">
                <div className="card-content">
                  <div className="card-title"> Goal Completion </div>
                  <div className="card-stats">
                    <div className="card-statistics-amount">79%</div>
                    <div className="progress">
                      <p><b>420</b> - completed </p>
                      <p><b>69</b> - failed </p>
                    </div>
                  </div>
                  <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={1}
                    colors={['#4e7dff']}
                    cornerRadius={0}
                    arcWidth={0.35}
                    percent={0.65}
                    needleColor="#ff69b4"
                    needleBaseColor="#ff69b4"
                    hideText={true}
                    needleScale={0.85}
                    style={{ width: 270, margin: 'auto' }}
                  />
                </div>
              </Card>
            </View>
          </View>
          <View>
            <Productivity
              classname="conversation-chart"
              colors={colors}
              data={productivityData}
              label={label}
              trafficSourceData={trafficSourceData}
              customScale={0.9}
            />
          </View>
        </Grid>

        <View columnSpan={[1]} rowSpan={{ base: 4, large: 4 }}>
          <Grid>
            <Card>
              <Grid className="table-title click">
                <View>
                </View>
                <View>
                  <Label className="filtercss">Filter by</Label>
                  <SelectField
                    label=""
                    size="small"
                  >
                    <option value="Date">Date</option>
                  </SelectField>
                </View>
              </Grid>
              <ThemeProvider theme={theme} colorMode="light">
                <Table highlightOnHover variation="striped">
                  <TableHead>
                    <TableRow>
                      <TableCell as="th">User</TableCell>
                      <TableCell as="th">Date / Time</TableCell>
                      <TableCell as="th">Query</TableCell>
                      <TableCell as="th">Action</TableCell>
                      <TableCell as="th">Outcome status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Bhuinya, Surajeet</TableCell>
                      <TableCell>25.07.2024 <br /> 17:24</TableCell>
                      <TableCell>Search for “P/E ratio” in document apple_earnings.pdf</TableCell>
                      <TableCell>Search_text</TableCell>
                      <TableCell><Button variation="primary" colorTheme="success" className="pass">Pass</Button>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Last Name, Name</TableCell>
                      <TableCell>DD.MM.YYYY <br />HH:MM</TableCell>
                      <TableCell>Question 1:1 </TableCell>
                      <TableCell>intent type</TableCell>
                      <TableCell><Button variation="primary" colorTheme="error" className="fail">Fail</Button>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Last Name, Name</TableCell>
                      <TableCell>DD.MM.YYYY <br />HH:MM</TableCell>
                      <TableCell>Question 1:1 </TableCell>
                      <TableCell>intent type</TableCell>
                      <TableCell><Button variation="primary" colorTheme="info" className="info"></Button>
                      </TableCell>
                    </TableRow>

                  </TableBody>
                </Table>
              </ThemeProvider>
            </Card>
          </Grid>
        </View>
      </View>
    </>
  );
};

export default Conversations;
